<template>
  <div class="role">
    <el-tabs :value="showAuthPage ? 'auth' : 'distribute'" class="my-tabs" :before-leave="distributeGetMember">
      <el-tab-pane v-if="showAuthPage" label="角色权限" name="auth">
        <el-container>
          <el-aside class="user-menu" width="200px">
            <el-row style="padding: 15px;">
              <el-col :span="12" class="user-icon">角色</el-col>
              <el-col @click.native="showAddRole = true" :span="12" class="user-add">添加角色</el-col>
            </el-row>
            <el-menu
              @select="getOneRole"
              class="el-menu-vertical-demo my-menu"
              text-color="rgb(102,102,102)"
              active-text-color="#EC1C1C">
              <el-menu-item :title="role.roleName" style="overflow-x: hidden; text-overflow: ellipsis;text-align: center;height: 46px;line-height: 46px;"
                            :id="'roleMenu'+index" v-for="(role,index) in roles" :index="role.corpRoleId + ''"
                            :key="index">
                {{role.roleName}}
              </el-menu-item>
            </el-menu>
          </el-aside>
          <el-main v-loading="rolesLoading">
            <div class="each-field">
              <span class="require">*</span>
              角色名称：
              <el-input v-model="inputUserInfo.username" class="common-inputs" placeholder="请输入"></el-input>
            </div>
            <div class="each-field">
              <span class="require">*</span>
              角色描述：
              <el-input v-model="inputUserInfo.userDescription" class="common-textarea" type="textarea" rows="3"
                        placeholder="100字以内" maxlength="100" style="vertical-align: top;">
              </el-input>
              <span class="inputs-length"
                    :style="{'color': inputUserInfo.userDescription.length >= 100 ? 'red' : '#606266'}">{{inputUserInfo.userDescription.length + '/ 100'}}</span>
            </div>
            <div class="each-field" style="min-height: 65%;">
              <span class="require" style="visibility: hidden;">*</span>
              权限分配：
              <div class="auth-wrapper">
                <!-- 可选权限 -->
                <div class="each-auth">
                  <div class="each-role" v-for="(item, index) in permEnum" :key="index">
                    <console-check class="roles-wrapper" style="height: 100%;" :checkObj="item">
                      <div class="auth-info" slot="template">
                        <p class="info">
                          <span class="title">{{item.name}}</span>
                          <span class="des">{{item.des}}</span>
                        </p>
                      </div>
                    </console-check>
                  </div>
                </div>
                <!-- 可选角色 -->
                <el-col :span="24" class="each-auth">
                  <p class="info">
                    <span class="title">角色分配</span>
                    <span class="des">将角色分配给相应的成员</span>
                  </p>
                  <div class="handles">
										 <div class="each-handle">
                      <el-checkbox v-model="checkedAllRole" @change="handleCheckChangeAllRole">所有角色</el-checkbox>
                    </div>
                    <div class="each-handle" v-for="(item, index) in oneRoleInfo.roleJson" :key="index">
                      <el-checkbox :checked="item.operType == 1" @change="handleCheckChange($event, item)">
                        {{oneRoleInfo.roleDistribute[index].roleName}}
                      </el-checkbox>
                    </div>
                  </div>
                </el-col>
                <!-- 可选签章 -->
                <!--<div class="each-auth">-->
                  <!--<p class="info">-->
                    <!--<span class="title">签章分配</span>-->
                    <!--<span class="des">可赋予给别人的授权签章</span>-->
                  <!--</p>-->
                  <!--<div class="each-seals-wrapper" v-for="(item, index) in oneRoleInfo.sealJson" :key="index">-->
                    <!--<console-check class="seals-wrapper" style="height: 100%;" :checkObj="item" :kv="{'operType': 1}">-->
                      <!--<div class="auth-info seals" slot="template">-->
                        <!--<img :src="fileOperShow(oneRoleInfo.sealDistribute[index].sealFile)">-->
                      <!--</div>-->
                    <!--</console-check>-->
                    <!--<p class="seal-name">{{oneRoleInfo.sealDistribute[index].sealName}}</p>-->
                  <!--</div>-->
                <!--</div>-->
              </div>
            </div>
            <div class="bottom-field">
              <el-button size="mini" @click="delRole">删除</el-button>
              <el-button size="mini" @click="saveRole" type="primary">保存</el-button>
            </div>
          </el-main>
        </el-container>
      </el-tab-pane>
      <el-tab-pane v-if="showDistributePage" class="distribute-pannel" label="角色分配" name="distribute">
        <div>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form :inline="true" :model="filterModel" class="filter-form">
                <el-form-item label="关键字">
                  <el-input style="width: 220px;" size="mini" v-model="filterModel.targetId"
                            placeholder="姓名/企业名称/邮箱/手机号"></el-input>
                </el-form-item>
                <el-form-item label="角色">
                  <el-select size="mini" v-model="filterModel.corpRoleId" placeholder="请选择角色">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="(role,index) in roles"
                      :label="role.roleName"
                      :value="role.corpRoleId"
                      :key="index"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button size="mini" @click="queryTool">搜索</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row>
            <el-table
              v-loading="distributeRoleLoading"
              ref="multipleTable"
              :data="memberList"
              border
              tooltip-effect="dark">
              <el-table-column label="姓名/企业名称" prop="userName" show-overflow-tooltip></el-table-column>
              <el-table-column label="账号(手机/邮箱)" prop="targetId" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.targetId">
                    {{scope.row.targetId}}
                  </span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column label="部门" prop="groupNames" show-overflow-tooltip></el-table-column>
              <el-table-column label="角色" prop="roleNames"/>
              <el-table-column label="类型" prop="useType">
                <template slot-scope="scope">
                  <!-- 0 个人 1 企业 -->
                  <p v-if="scope.row.useType === 0">
                    个人
                  </p>
                  <p v-if="scope.row.useType === 1">
                    企业
                  </p>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="handleDistribute(scope.row)">分配</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row class="pageation">
            <el-col :span="24" style="padding: 30px 0;" class="page-flex-end">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="filterModel.itemPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="filterModel.pageSize"
                layout="sizes, prev, pager, next, total"
                :total="filterModel.pageTotal"
              />
              <el-go 
                :page-size="filterModel.pageSize"
                :total="filterModel.pageTotal"
                @current-change="handleCurrentChange"></el-go>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
    <transition name="fade">
      <div class="add-role-back" v-show="showAddRole">
        <div class="background" @click="closeAddRole"></div>
        <div class="add-role">
          <div class="head">
            添加角色
            <i class="el-icon-close" @click="closeAddRole"></i>
          </div>
          <div class="body">
            <div class="add-role-field">
              <span class="require">*</span>
              角色名称：
              <el-input v-model="addRoleInfo.username" maxlength="15" class="role-input" placeholder="请输入"></el-input>
              <span class="inputs-length input"
                    :style="{'color': addRoleInfo.username.length >= 15 ? 'red' : '#606266'}">{{addRoleInfo.username.length + '/ 15'}}</span>
            </div>
            <div class="add-role-field">
              <span class="require">*</span>
              角色描述：
              <el-input v-model="addRoleInfo.userDescription" class="role-textarea" type="textarea" rows="3"
                        placeholder="100字以内" maxlength="100" style="vertical-align: top;">
              </el-input>
              <span class="inputs-length"
                    :style="{'color': addRoleInfo.userDescription.length >= 100 ? 'red' : '#606266'}">{{addRoleInfo.userDescription.length + '/ 100'}}</span>
            </div>
          </div>
          <div class="foot">
            <el-button size="mini" @click="closeAddRole">取消</el-button>
            <el-button size="mini" type="primary" @click="addRole">确定</el-button>
          </div>
        </div>
      </div>
    </transition>
    <el-dialog class="custom-table" width="50%" top="10vh" title="角色分配" :visible.sync="showDistribute"
               @close="clearSelection('roleSelection')">
      <el-row style="margin-bottom: 10px;margin-top: -10px;">部门：{{distibuteInfo.groupNames}}</el-row>
      <el-row style="margin-bottom: 10px;">姓名：{{distibuteInfo.userName}}</el-row>
      <el-row>
        <template v-if="distibuteInfo.type == 0">手机：{{distibuteInfo.accout}}</template>
        <template v-else-if="distibuteInfo.type == 1">邮箱：{{distibuteInfo.accout}}</template>
      </el-row>
      <el-row>
        <el-row>角色：</el-row>
        <el-table
          ref="roleSelection"
          :data="distributeRoles"
          @selection-change="distributeRoleSelect"
          :default-sort="{prop: 'corpRoleId', order: 'ascending'}"
          border>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column property="roleName" label="角色名称" width="200"></el-table-column>
          <el-table-column property="groupName" label="权限范围"></el-table-column>
          <el-table-column label="操作" width="140">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="chooseAuth(scope.row)">选择权限范围</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!--<el-row>可使用的签章：</el-row>-->
      <!--<el-row :gutter="20" justify="center">
        <el-col :span="6" v-for="(seal, index) in distributeSealJson" :key="index" style="margin-bottom: 10px;">
          <el-card :shadow="'hover'" :body-style="{ padding: '0', textAlign: 'center'}">
            <div class="seal-wrapper">
              <img :src="fileOperShow(distributeSeals[index].sealFile)">
            </div>
            <div style="padding: 5px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
              <span>{{distributeSeals[index].sealName}}</span>
              <div class="bottom clearfix">
                <el-checkbox :checked="seal.operType == 1" @change="seal.operType = arguments[0] ? 1 : 0"></el-checkbox>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>-->
      <!--<div class="each-seals-wrapper" v-for="(item, index) in distributeSealJson" :key="index">-->
        <!--<console-check class="seals-wrapper" style="height: 100%;" :checkObj="item" :kv="{'operType': 1}">-->
          <!--<div class="auth-info seals" slot="template">-->
            <!--<img :src="fileOperShow(distributeSeals[index].sealFile)">-->
          <!--</div>-->
        <!--</console-check>-->
        <!--<p class="seal-name">{{distributeSeals[index].sealName}}</p>-->
      <!--</div>-->
      <el-row slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showDistribute = false">取消</el-button>
        <el-button size="mini" type="primary" @click="doDistribute">确定</el-button>
      </el-row>
      <el-dialog title="选择权限范围" :visible.sync="showChooseAuth" append-to-body>
        <el-tree
          :data="treeGroup"
          node-key="corpGroupId"
          :default-expanded-keys="treeGroupKeys"
          :highlight-current="true"
          :props="defaultProps"
          @node-click="checkGroup">
        </el-tree>
        <el-row slot="footer" class="dialog-footer">
          <el-button size="mini" @click="showChooseAuth = false">取消</el-button>
          <el-button size="mini" type="primary" @click="doChooseAuth">确定</el-button>
        </el-row>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
  import {ApiCorpMethods} from '@/assets/js/http-serve/corp/http-methods';
  import {fileOperShow} from '../../assets/js/http-serve/http-methods'
  import ElGo from '../../components/go/Go'
  import showRes from '@/assets/js/http-serve/corp/showApiRes';
  import ConsoleCheck from '@/components/console-check'

  export default {
    name: "role",
    components: {ElGo, ConsoleCheck},
    beforeMount() {
      this.judgeShowPages();
      this.getWindowHeight();
    },
    data() {
      return {
				// 所有角色
				checkedAllRole: false,
        rolesLoading: false,
        distributeRoleLoading: false,
        showAuthPage: false,
        showDistributePage: false,
        height: '100%',
        inputUserInfo: {
          username: '',
          userDescription: '',
        },
        addRoleInfo: {
          username: '',
          userDescription: '',
        },
        roles: [],
        oneRoleInfo: {
          roleId: 0,
          perms: [],
          roleDistribute: [],
          roleJson: [],
          sealDistribute: [],
          sealJson: [],
        },
        permEnum: [
          {
            pid: 3,
            name: "成员管理",
            des: "邀请个人或企业加入您的组织，也可将成员移除组织。",
            checked: false
          },
          {
            pid: 4,
            name: "签章管理",
            des: "进入签章管理中添加删除或编辑签章样式",
            checked: false
          },
          {
            pid: 5,
            name: "合同管理",
            des: "可在合同管理中在线查看合同并且可进行下载",
            checked: false
          },
          {
            pid: 7,
            name: "组织管理",
            des: "创建或删除下级组织",
            checked: false
          },
          {
            pid: 8,
            name: "角色权限",
            des: "进入角色权限中添加删除任何角色",
            checked: false
          },
          {
            pid: 10,
            name: "审计日志",
            des: "查看签章日志和控制台操作日志",
            checked: false
          },
          {
            pid: 6,
            name: "模板管理",
            des: "规定合同模板，签署文件更规范",
            checked: false
          },
          {
            pid: 12,
            name: "审批流程",
            des: "进入合同审批流程添加审批",
            checked: false
					},
					{
            pid: 13,
            name: "法律维权",
            des: "查询或操作法律维权订单",
            checked: false
          }
        ],
        showAddRole: false, //控制添加角色窗口显隐

        showDistribute: false, //控制分配角色窗口显隐
        showChooseAuth: false, //控制选择权限范围窗口

        //角色分配
        memberList: [], //成员列表
        queryMemberParam: {},
        distibuteInfo: {},  //分配成员的信息
        distributeSeals: [], //分配成员 可用签章
        distributeRoles: [],  //分配成员 可用角色
        distributeRoleJson: [],
        distributeSealJson: [],
        filterModel: {
          targetId: '', // 手机/邮箱 ... 关键字
          corpRoleId: '', // 角色id
          useType: '', // 用户类型 0个人1企业
          itemPage: 1,
          pageSize: 10,
          pageTotal: 0
        },
        treeGroup: [],
        treeGroupKeys: [],
        chooseRange: null,
        currentRoleRow: {},
        departmentArray: [],
        defaultProps: {
          children: 'childCorpGroups',
          label: 'label'
        },
        fileOperShow: fileOperShow
      }
    },
    methods: {
			handleCheckChange(v, item) {
				item.operType = v ? 1 : 0
				this.checkedAllRole = true
				const element = JSON.parse(JSON.stringify(this.oneRoleInfo.roleJson))
				for (let index = 0; index < element.length; index++) {
					if (element[index].operType === 0) {
						this.checkedAllRole = false
					}
				}
			},
			// handle change event of all role
			handleCheckChangeAllRole(v) {
				const element = JSON.parse(JSON.stringify(this.oneRoleInfo.roleJson))
				this.oneRoleInfo.roleJson = []
				if (v) {
					for (let index = 0; index < element.length; index++) {
						element[index].operType = 1;
					}
				} else {
					for (let index = 0; index < element.length; index++) {
						element[index].operType = 0;
					}
				}
				this.$nextTick(() => {
					this.oneRoleInfo.roleJson = element
				})
			},
      //判断权限是否显示角色权限 和 角色分配
      judgeShowPages() {
        try {
          this.$nextTick(() => {
            let perms = this.$store.getters.consoleToken.perms;
            for (let i = 0, length = perms.length; i < length; i++) {
              if (perms[i] == 8) {
                //角色权限
                this.showAuthPage = true;
              } else if (perms[i] == 9) {
                //角色分配
                this.showDistributePage = true;
              }
            }
            if (perms.indexOf(8) >= 0) {
              //获取角色权限内容
              this.getAllRoles();
            } else if (perms.indexOf(9) >= 0) {
              //获取角色分配内容
              this.queryTool();
            }
          })
        } catch (e) {
          console.log(e);
        }
      },
      //获取所有
      async getAllRoles() {
        this.rolesLoading = true;
        let rolesRes = await ApiCorpMethods.RoleController.roles();
        this.rolesLoading = false;
        if (rolesRes.success) {
          this.roles = rolesRes.data;
          //点击第一个角色
          this.$nextTick(() => {
            let roleMenu = document.getElementById('roleMenu0');
            if (roleMenu && roleMenu.click) {
              roleMenu.click();
            }
          })
        } else {
          showRes(rolesRes);
        }
      },
      //获取一名角色信息
      getOneRole(index) {
        //重置oneRoleInfo
        this.oneRoleInfo =
          {
            roleId: index,
            perms: [],
            roleDistribute: [],
            roleJson: [],
            sealDistribute: [],
						sealJson: []
          };
        this.getAuthRole(index);
        this.getAuthSeal(index);

        this.getRoleDetail(index);
      },
      async getRoleDetail(index) {

        //清除选中状态
        this.permEnum.forEach(permItem => {
          permItem.checked = false;
        });

        //获取角色详情
        let res = await ApiCorpMethods.RoleController.detail({corpRoleId: index});

        if (res.success && res.data) {
					// 所有角色
					if (res.data.allRole) {
						this.checkedAllRole = true
					} else {
						this.checkedAllRole = false
					}
          //初始化角色权限选中状态
          if (res.data.perms) {
            res.data.perms.forEach(perm => {
              this.permEnum.forEach(permItem => {
                if (perm == permItem.pid) {
                  permItem.checked = true;
                }
              });
            });
          }

          this.inputUserInfo.username = res.data.roleName || '';
          this.inputUserInfo.userDescription = res.data.remark || '';
        }
      },
      //获取 角色权限-角色
      async getAuthRole(corpRoleId) {
        let res = await ApiCorpMethods.RoleController.detailAssignRoles({corpRoleId, pageSize: 10000});
        if (!res.success) {
          showRes(res);
          return;
        }

        this.oneRoleInfo.roleDistribute = res.data;
        this.oneRoleInfo.roleJson = []; //清空roleJson
        res.data.forEach((role) => {
          let oneRoleJson = {
            corpRoleId: role.corpRoleId,
            operType: role.assigned
          }
          this.oneRoleInfo.roleJson.push(oneRoleJson);
        });
      },

      //获取 角色权限-公章
      async getAuthSeal(corpRoleId) {
        let res = await ApiCorpMethods.RoleController.detailAssignSeals({corpRoleId});
        if (!res.success) {
          showRes(res);
          return;
        }
        this.oneRoleInfo.sealDistribute = res.data;
        this.oneRoleInfo.sealJson = []; //清空sealJson
        res.data.forEach((seal) => {
          let oneSealJson = {
            corpSealId: seal.corpSealId,
            operType: seal.assigned
          }
          this.oneRoleInfo.sealJson.push(oneSealJson);
        });
      },
      getWindowHeight() {
        this.height = window.innerHeight - 110 + 'px';
      },
      //添加角色
      async addRole() {
        if (!this.addRoleInfo.username || !this.addRoleInfo.userDescription) {
          this.$message({
            message: '请输入角色信息',
            type: 'warning'
          });
          return;
        }
        let param = {
          roleName: this.addRoleInfo.username,
          remark: this.addRoleInfo.userDescription
        }
        let roleRes = await ApiCorpMethods.RoleController.operRole(param);
        if (!roleRes.success) {
          showRes(roleRes);
          return;
        }
        this.getAllRoles();
        this.closeAddRole();
      },
      async saveRole() {
        if (!this.inputUserInfo.username || !this.inputUserInfo.userDescription) {
          this.$message({
            message: '请输入角色信息',
            type: 'warning'
          });
          return;
        }

        let rolesJson = this.oneRoleInfo.roleJson ? JSON.stringify(this.oneRoleInfo.roleJson) : '';
				let sealsJson = this.oneRoleInfo.sealJson ? JSON.stringify(this.oneRoleInfo.sealJson) : '';
				// 所有角色 param
				let allRole = this.checkedAllRole ? 1 : 0;
        let param = {
          corpRoleId: this.oneRoleInfo.roleId,
          roleName: this.inputUserInfo.username,
          remark: this.inputUserInfo.userDescription,
          perms: this.getCheckedPerms().join(),
          rolesJson,
					sealsJson,
					allRole
        }
        let roleRes = await ApiCorpMethods.RoleController.operRole(param);
        showRes(roleRes);
        this.getAllRoles();
      },
      getCheckedPerms() {
        let perms = [];
        this.permEnum.forEach(permItem => {
          if (permItem.checked === true) {
            perms.push(permItem.pid);
          }
        });
        return perms;
      },
      delRole() {
        this.$confirm('<p style="font-size: 16px;"><i class="el-icon-warning" style="color: #e6a23c;font-size: 20px; width: 30px;"></i>是否删除角色</p><p style="font-size: 14px; color: #a6a69e;padding-left: 30px;"><span style="color: red;">删除角色将不会恢复</span>，你还要继续吗？</p>', '', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: ''
        }).then(async () => {
          let delRes = await ApiCorpMethods.RoleController.delRole({corpRoleId: this.oneRoleInfo.roleId});
          showRes(delRes);
          if (delRes.success) this.getAllRoles();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      closeAddRole() {
        this.showAddRole = false;
        this.addRoleInfo.username = '';
        this.addRoleInfo.userDescription = '';
      },
      handleSizeChange(val) {
        this.filterModel.itemPage = 1;
        this.filterModel.pageSize = val;
        this.queryTool();
      },
      handleCurrentChange(val) {
        this.filterModel.itemPage = val;
        this.queryTool();
      },
      //显示角色分配
      distributeGetMember(activeName, oldActiveName) {
        if (activeName == 'distribute' && this.memberList.length <= 0) {
          this.queryTool();
        }
      },
      //获取 角色分配-角色
      async getListAssignRole(row) {
        let param = {
          corpUserId: row.corpUserId,
          itemPage: 1,
          pageSize: 50
        }
        let res = await ApiCorpMethods.RoleController.listAssignRole(param);
        if (!res.success) return showRes(res);
        this.distributeRoles = res.data;

        this.$nextTick(() => {
          this.distributeRoles.forEach((role, index) => {
            //初始化roleJson数据
            this.distributeRoleJson.push({
              corpRoleId: role.corpRoleId,
              corpGroupId: role.corpGroupId,
              operType: role.assigned == 1 ? 1 : 0,
            });

            //默认选中已分配的角色
            if (role.assigned == 1) {
              this.$refs.roleSelection.toggleRowSelection(this.distributeRoles[index], true)
            }
          });
        });
      },
      async getListAssignSeal(row) {
        let param = {
          corpUserId: row.corpUserId,
          itemPage: 1,
          pageSize: 50
        };
        let res = await ApiCorpMethods.RoleController.listAssignSeal(param);
        if (!res.success) return showRes(res);
        this.distributeSeals = res.data;
        this.$nextTick(() => {
          this.distributeSeals.forEach(seal => {
            this.distributeSealJson.push({
              corpSealId: seal.corpSealId,
              operType: seal.assigned == 1 ? 1 : 0,
            });
          });
        });
      },

      //分配按钮
      handleDistribute(row) {
        this.distributeRoleJson = [];
        this.distributeSealJson = [];
        this.distibuteInfo = row;
        this.getListAssignRole(row);
        this.getListAssignSeal(row);
        this.showDistribute = true;
      },
      //角色分配-选择角色时触发
      distributeRoleSelect(val) {
        for (let i = 0, jsonLength = this.distributeRoleJson.length; i < jsonLength; i++) {
          let matched = false;

          //循环判断是否选中
          for (let j = 0, length = val.length; j < length; j++) {
            if (this.distributeRoleJson[i].corpRoleId === val[j].corpRoleId) {
              this.distributeRoleJson[i].operType = 1;
              matched = true;
              break;
            }
          }

          //没有匹配，则设置为不选中
          if (!matched) {
            this.distributeRoleJson[i].operType = 0;
          }
        }
      },
      chooseAuth(row) {
        this.getAuthRange(row);
        this.showChooseAuth = true;
      },
      doChooseAuth() {
        if (this.chooseRange) {
          this.currentRoleRow.groupName = this.chooseRange.groupName;
          this.currentRoleRow.corpGroupId = this.chooseRange.corpGroupId;
          this.$refs.roleSelection.toggleRowSelection(this.currentRoleRow);
          this.$refs.roleSelection.toggleRowSelection(this.currentRoleRow);
          this.$nextTick(() => {
            //根据角色id设置对应的RoleJson中的corpGroupId
            this.distributeRoleJson.forEach(role => {
              if (role.corpRoleId == this.currentRoleRow.corpRoleId) {
                role.corpGroupId = this.currentRoleRow.corpGroupId;
              }
            });
          });
        }
        this.showChooseAuth = false;

      },
      async doDistribute() {
        let param = {
          rolesJson: JSON.stringify(this.distributeRoleJson),
          sealsJson: '',
          corpUserId: this.distibuteInfo.corpUserId
        };
        let res = await ApiCorpMethods.RoleController.assignRole(param);
        showRes(res);
        if (!res.success) return;
        this.queryTool();
        this.showDistribute = false;
      },
      async getAuthRange(row) {
        this.currentRoleRow = null;
        this.currentRoleRow = row; //地址赋值，便于修改row
        let res = await ApiCorpMethods.OrganizationController.treeGroup({permId: 9});
        if (!res.success) return showRes(res);
        this.treeGroup = this.convertFormateTree(res.data);
      },
      // 转换成tree需要的数据格式
      convertFormateTree(data) {
        data.forEach(element => {
          this.departmentArray.push(element)
          element.label = element.groupName + '(' + element.totalNum + '人)'
          if (element.childCorpGroups) {
            this.recursionChildren(element.childCorpGroups)
          }
        });
        return data
      },
      //点击每一个权限范围子节点时触发
      checkGroup(groupObj, node, nodeComp) {
        this.chooseRange = groupObj;
      },
      recursionChildren(childCorpGroups) {
        childCorpGroups.forEach(element => {
          this.departmentArray.push(element)
          element.label = element.groupName + '(' + element.totalNum + '人)'
          this.treeGroupKeys.push(element.corpGroupId);
          if (element.childCorpGroups) {
            this.recursionChildren(element.childCorpGroups)
          }
        })
      },
      clearSelection(refName) {
        if (this.$refs[refName]) {
          this.$refs[refName].clearSelection();
        }
      },
      async queryTool() {
        /**
         * table data desription
         * "corpRoleId": 0 高级管理员 1 普通员工 2 签章使用人 3 合同查看人
         * "type": 0 个人 1 企业
         */
        this.distributeRoleLoading = true;
        this.filterModel.permId = 9
        let memRes = await ApiCorpMethods.MemberController.listCorpUsers(this.filterModel);
        this.distributeRoleLoading = false;
        if (memRes.success && memRes.data) {
          this.memberList = memRes.data;
          this.filterModel.pageTotal = memRes.total
        } else {
          showRes(memRes);
        }
      }
    },
  }
</script>

<style lang="less" scoped>
	/deep/ .custom-table {
		table {
			th { padding: 8px 0; }
		}
		.el-table__row {
			td { padding: 5px 0; }
		}
	}
  /deep/ .my-tabs {
    padding-top: 10px;
    .el-tabs__header {
      margin-bottom: 0;
      padding: 0 20px;
    }
    .el-tabs__item {
      margin-right: 20px;
      padding: 0 40px !important;
    }
    .el-tabs__active-bar {
      width: 136px !important;
    }
    .el-tabs__nav-wrap {
      &:after {
        height: 1px;
      }
    }
    .user-menu {
      border-right: 1px solid #e4e7ed;
      .my-menu {
        border-right: none;
        .is-active {
          color: #EC1C1C;
					border-right: 2px solid #EC1C1C;
					background: #F2F2F2;
        }
      }
      .user-icon {
        text-align: left;
        color: #656565;
        font-size: 16px;
        font-weight: bold;
      }
      .user-add {
        text-align: right;
        color: #ec1c1c;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .el-main {
      padding: 40px 30px 60px 40px;
      .each-field {
        position: relative;
        margin-bottom: 30px;
        &:after {
          content: '';
          display: block;
          clear: both;
        }
        .require {
          color: red;
          vertical-align: middle;
        }
        .common-inputs {
          width: 320px;
        }
        .common-textarea {
          width: calc(100% - 85px);
        }
        .inputs-length {
          position: absolute;
          right: 20px;
          bottom: 5px;
        }
        .auth-wrapper {
          width: calc(100% - 84px);
          float: right;
          &:after {
            content: '';
            display: block;
            clear: both;
          }
          .each-auth {
            position: relative;
            .auth-info {
              text-align: center;
              line-height: 2;
              .info {
                .title {
                  margin-bottom: 10px;
                }
                .des {
                  height: auto;
                  line-height: 2;
                }
              }
            }
            .info {
              width: 90%;
							line-height: 2;
							margin-bottom: 5px;
              span {
                display: block;
              }
              .title {
                font-weight: 600;
                font-size: 14px;
                color: #000;
              }
              .des {
                line-height: 18px;
                font-size: 12px;
                color: rgb(153, 153, 153);
                overflow-y: hidden;
                text-overflow: ellipsis;
              }
            }
            .each-role {
              display: inline-block;
              width: 250px;
              padding: 0 45px 20px 0;
              .roles-wrapper {
                height: 0;
                padding-bottom: 60%;
                .auth-info {
                  width: 90%;
                  position: absolute;
                  top: 50%;
                  left: 5%;
                  transform: translateY(-50%);
                }
              }
            }
            .handles {
              width: 100%;
              float: left;
              .el-checkbox {
                margin-left: 0;
                line-height: 2;
              }
              .each-handle {
                display: inline-block;
                margin-right: 30px;
              }
              &.seal-handles {
                .each-handle {
                  width: 22%;
                  max-width: 200px;
                  margin-right: 2%;
                }
              }
              .each-handle-img {
                width: 100%;
                margin-top: 20px;
                display: inline-block;
                text-align: center;
                margin-right: 12%;
                p {
                  line-height: 1.5;
                  margin-top: 8px;
                }
              }
            }
            &:after {
              content: '';
              display: block;
              clear: both;
            }
          }
        }
      }
      .bottom-field {
        position: fixed;
        z-index: 2;
        width: calc(100% - 400px);
        bottom: 0;
        padding-right: 30px;
        box-sizing: content-box;
        line-height: 60px;
        margin-left: -40px;
        background-color: #fff;
        text-align: right;
        box-shadow: 0 -3px 4px rgba(0, 0, 0, 0.1);
        .btns {
          vertical-align: middle;
          padding: 8px 25px;
        }
      }
    }
  }
  .each-seals-wrapper {
    display: inline-block;
    padding: 20px 40px 20px 0;
    width: 200px;
    .seals-wrapper {
      height: 0 !important;
      padding-bottom: 100%;
      .seals {
        img {
          width: 90%;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          position: absolute;
        }
      }
      &.checked + .seal-name {
        color: #ec1c1c;
      }
    }
    .seal-name {
      width: 100%;
      text-align: center;
    }
  }

  .el-button--text {
    color: #ec1c1c;
  }

  /deep/ .el-tabs__item {
    &.is-active {
      color: #ec1c1c;
    }
    &:hover {
      color: #ec1c1c;
    }
  }

  /deep/ .el-tabs__active-bar {
    background-color: #ec1c1c;
  }

  .add-role-back {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    vertical-align: middle;
    z-index: 2001;
    &:after {
      content: "";
      display: inline-block;
      height: 100%;
      width: 0;
      vertical-align: middle;
    }
    .background {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      z-index: -1;
    }
    .add-role {
      width: 500px;
      display: inline-block;
      vertical-align: middle;
      background-color: #fff;
      .head {
        padding: 20px;
        vertical-align: middle;
        text-align: left;
        .el-icon-close {
          float: right;
          font-size: 18px;
          cursor: pointer;
          &:hover {
            color: #00abea;
          }
        }
      }
      .body {
        border-style: solid;
        border-color: #dcdfe6;
        border-width: 1px 0;
        .add-role-field {
          padding: 15px 30px;
          position: relative;
          .require {
            color: red;
          }
          .role-input {
            width: calc(100% - 90px);
          }
          .role-textarea {
            width: calc(100% - 90px);
          }
          .inputs-length {
            position: absolute;
            right: 50px;
            bottom: 20px;
            &.input {
              bottom: 50%;
              margin-bottom: -10px;
            }
          }
        }
      }
      .foot {
        text-align: right;
        padding: 10px 25px;
        .el-button {
          padding: 8px 15px;
        }
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .filter-field {
    padding: 15px 30px;
    margin-bottom: 20px;
    background-color: #f7f7f7;
    .el-form-item {
      margin-bottom: 0;
      margin-right: 30px;
    }
  }

  .seal-wrapper {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    position: relative;
    text-align: center;
    background-color: #eee;
    img {
      max-width: 90%;
      max-height: 90%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }

  /deep/ .el-checkbox__input {
    &.is-checked {
      & + .el-checkbox__label {
        color: #EC1C1C !important;
      }
    }
  }

  .distribute-pannel {
    padding: 10px 20px;
    .filter-form {
      margin-bottom: 10px;
      .el-form-item {
        margin-bottom: 0;
      }
    }
    /deep/ thead {
      background-color: #f9f9f9;
      tr {
        background-color: #f9f9f9;
        th {
					color: #000;
          background-color: #f9f9f9;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pages/console/role.vue